import {
    ACTIVE,
    ALERT_ASSET_STATUS_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE,
    ALERT_UPDATE_SUCCESS_ASSET_MESSAGE,
    ALL_CONFIG,
    ASL_ASSET_TYPE, DEPRECATED,
    ENDPOINT_GET_ASL_STATUS,
    LOADING_FAILED,
    LOADING_STRING,
    ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET, DEFAULT_VENDOR_ATTRIBUTES, getUpdateAssetMessageAlertWithSite,
} from "../../../util/Constants";
import {
    chainWalk,
    checkInactiveOrDeprecatedAsset,
    checkNullAndUndefinedAttribute,
    convertTableJsonToAsset, deepCopyObject,
    getAPIGatewayPostRequest, getAssetLabelFromMac,
    getNodeId,
    logOperationalMetric,
    getAliasFromParent, setAliasToRequest, isResponseCode5xx,
} from "../../../util/Util";
import {
    addAsset,
    getAssetByAssetLabel,
    getAssets,
    setAssetStatus,
    updateAsset, updateAssetInPlace
} from "../../../resources/AssetResource";
import {getAPIGatewayDataFromParent} from "../../../handler/ParentDataHandler";
import {updateConfigurationsInAslAssetObject} from "../datamodel/AslAssetModelResource";

const metricProcessName = "ASL_DEVICE_DETAILS";

export function fetchAslDeviceDetails(dispatcher) {
    const request = {
        nodeId: getNodeId(),
        assetType: ASL_ASSET_TYPE
    }
    getAslDeviceDetails(dispatcher, request)
}

export function fetchAslStatusDetails(dispatcher, model) {
    getAslDeviceStatusDetails(dispatcher, model)
}

export function deleteAslDeviceDetails(dispatcher, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        },
        assetStatus: DEPRECATED
    }
    setAssetLabelDeprecatedAslDeviceDetails(dispatcher, request)
}

export function setAslDeviceDetails(dispatcher, stateValues) {
    stateValues.mac = stateValues.mac.toLowerCase();
    const request = convertTableJsonToAsset(stateValues, ASL_ASSET_TYPE, ACTIVE);
    addAslDeviceDetails(dispatcher, request)
}

export async function updateAslDeviceMac(dispatcher, stateValues, mac) {
    const startTime = Date.now();
    const assetLabel = getAssetLabelFromMac(stateValues.mac.toLowerCase());
    const assetResult = await getAssetByAssetLabel(assetLabel);
    const nodeId = chainWalk(() => assetResult.data.asset.assetDetails.nodeId, null);
    const assetStatus = chainWalk(() => assetResult.data.asset.assetDetails.assetStatus, null);
    if (assetStatus && !checkInactiveOrDeprecatedAsset(assetStatus)) {
        alert(getUpdateAssetMessageAlertWithSite(nodeId));
        logOperationalMetric(startTime, metricProcessName, "addAslDeviceDetails", false, false);
    } else {
        deleteAslDeviceDetails(dispatcher, mac);
        setAslDeviceDetails(dispatcher, stateValues);
    }
}

export function updateAslDeviceDetails(dispatcher, stateValues) {
    const request = convertTableJsonToAsset(stateValues, ASL_ASSET_TYPE, ACTIVE);
    updateAslAsset(dispatcher, request)
}

export const updateAslDivertConfig = (result, divertConfig) => {
    const temp = [divertConfig]
    if (checkNullAndUndefinedAttribute(result.assetDetails.assetAttributes.divertConfig)) {
        for (const object of JSON.parse(result.assetDetails.assetAttributes.divertConfig)) {
            if (object.divertCode !== divertConfig.divertCode) {
                temp.push(object)
            }
        }
    }
    result.assetDetails.assetAttributes.divertConfig = JSON.stringify(temp)
    return result;
}

export const deleteAslDivertConfig = (result, divertCode) => {
    const temp = []
    if (divertCode !== ALL_CONFIG) {
        if (checkNullAndUndefinedAttribute(result.assetDetails.assetAttributes.divertConfig)) {
            for (const key of JSON.parse(result.assetDetails.assetAttributes.divertConfig)) {
                if (key.divertCode !== divertCode)
                    temp.push(key)
            }
        }
    }
    result.assetDetails.assetAttributes.divertConfig = JSON.stringify(temp)
    return result;
}

export const updateAslConfiguration = async (dispatcher, configurations, mac) => {
    // Get existing configuration
    const getAssetResult = await getAssetByAssetLabel(getAssetLabelFromMac(mac));

    // Merge current configuration into existing configuration and update
    const startTime = Date.now();
    const alias = await getAliasFromParent();
    const updatedAsset = updateConfigurationsInAslAssetObject(getAssetResult.data.asset, configurations, alias);
    const updateResult = await updateAsset(updatedAsset, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
    const isUpdateSuccess = updateResult.status === 200;
    const isFault = isResponseCode5xx(updateResult.status)
    fetchAslDeviceDetails(dispatcher)

    // Log operation
    isUpdateSuccess ? alert(ALERT_UPDATE_SUCCESS_ASSET_MESSAGE) : alert(ALERT_UPDATE_ASSET_MESSAGE);
    logOperationalMetric(startTime, metricProcessName, "updateAslConfiguration", isUpdateSuccess, isFault);
}

const extractAslDeviceInformation = (result) => {
    const model = {
        aslDeviceInformation: {},
        macAddressArray: []
    }
    if ("data" in result && "assetDetailsList" in result.data) {
        result.data.assetDetailsList.forEach((aslDeviceDetail) => {
            if (aslDeviceDetail.assetStatus === ACTIVE) {
                model.macAddressArray.push(aslDeviceDetail.assetAttributes.mac)
                const deviceConfig = JSON.parse(aslDeviceDetail.assetAttributes.deviceConfig);
                model.aslDeviceInformation[aslDeviceDetail.assetAttributes.mac] = {
                    name: aslDeviceDetail.assetAttributes.name,
                    mac: aslDeviceDetail.assetAttributes.mac,
                    ip: aslDeviceDetail.assetAttributes.ip,
                    id: deviceConfig.id,
                    responsePort: deviceConfig.responsePort,
                    inductLocation: deviceConfig.inductLocation,
                    userId: deviceConfig.userId,
                    port: aslDeviceDetail.assetAttributes.port,
                    vendorAttributes: aslDeviceDetail.vendorAttributes || DEFAULT_VENDOR_ATTRIBUTES,
                    assetStatus: LOADING_STRING,
                    deviceType: aslDeviceDetail.assetAttributes.deviceType,
                    assetType: aslDeviceDetail.assetType,
                    divertConfig: chainWalk(() => JSON.parse(aslDeviceDetail.assetAttributes.divertConfig), []),
                    startTime: chainWalk(() => JSON.parse(aslDeviceDetail.assetAttributes.monitoring).startTime, "0"),
                    endTime: chainWalk(() => JSON.parse(aslDeviceDetail.assetAttributes.monitoring).endTime, "0"),
                    reason: chainWalk(() => JSON.parse(aslDeviceDetail.assetAttributes.monitoring).reason, ""),
                }
            }
        });
    }
    return model;
}

async function getAslDeviceStatusDetails(dispatcher, model) {
    const request = {
        nodeId: getNodeId(),
        macAddressList: model.macAddressArray
    }
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_ASL_STATUS);
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "getAslDeviceStatusDetails", true, false);
        mergeStatusToModel(response, model)
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "getAslDeviceStatusDetails", false, isFault);
        request.macAddressList.forEach((macAddress) => {
            model.aslDeviceInformation[macAddress].assetStatus = LOADING_FAILED
        })
    }
    dispatcher({type: "RECEIVE_DATA", data: model});
}

async function getAslDeviceDetails(dispatcher, request) {
    // Get assets
    const startTime = Date.now();
    const response = await getAssets(request.nodeId, request.assetType)
    const isSuccess = response.status === 200
    const isFault = isResponseCode5xx(response.status)

    // Extract data
    const aslDeviceInformation = extractAslDeviceInformation(response);

    // Fork status call
    if (aslDeviceInformation.macAddressArray) {
        await getAslDeviceStatusDetails(dispatcher, aslDeviceInformation)
    }

    // Return data to page
    dispatcher({type: "RECEIVE_DATA", data: aslDeviceInformation});

    // Log operation
    logOperationalMetric(startTime, metricProcessName, "getAslDeviceDetails", isSuccess, isFault);
}

async function setAssetLabelDeprecatedAslDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    setAssetStatus(request.assetLabel, request.assetStatus).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "deleteAslDeviceDetails", true, false);
        } else {
            const isFault = isResponseCode5xx(result.status)
            logOperationalMetric(startTime, metricProcessName, "deleteAslDeviceDetails", false, isFault);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

async function addAslDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    await setAliasToRequest(request);
    addAsset(request).then(async result => {
        const isFault = isResponseCode5xx(result.status)
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "addAslDeviceDetails", true, false);
        } else {
            // 500 response status can be for any reason. One of those is : asset already exists so trying to update it.
            // UpdateAsset only works on ACTIVE devices so first setting status as ACTIVE.
            const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
            if (!checkInactiveOrDeprecatedAsset(getAssetResult.data.asset.assetDetails.assetStatus)) {
                alert(ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET);
                logOperationalMetric(startTime, metricProcessName, "addAslDeviceDetails", false, isFault);
                return;
            }
            const responseSetAssetStatus = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
            if (responseSetAssetStatus.status !== 200) {
                alert(ALERT_ASSET_STATUS_MESSAGE);
                logOperationalMetric(startTime, metricProcessName, "addAslDeviceDetails", false, isFault);
                return;
            }
            const responseUpdateAsset = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
            if (responseUpdateAsset.status !== 200) {
                const isFaultInUpdate = isResponseCode5xx(responseUpdateAsset.status)
                alert(ALERT_UPDATE_ASSET_MESSAGE);
                logOperationalMetric(startTime, metricProcessName, "addAslDeviceDetails", false, isFaultInUpdate);
                return;
            }
            logOperationalMetric(startTime, metricProcessName, "addAslDeviceDetails", true, false);
        }
        fetchAslDeviceDetails(dispatcher)
    });
}


async function updateAslAsset(dispatcher, request) {
    // Set asset to active first
    const setAssetStatusResponse = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
    if (setAssetStatusResponse.status !== 200) {
        alert(ALERT_ASSET_STATUS_MESSAGE);
        fetchAslDeviceDetails(dispatcher)
        return;
    }

    // Update asset details
    const startTime = Date.now();
    await setAliasToRequest(request);
    const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
    const updateAssetResponse = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
    const isSuccess = updateAssetResponse.status === 200;
    const isFault = isResponseCode5xx(updateAssetResponse.status)
    logOperationalMetric(startTime, metricProcessName, "updateAslDeviceDetails", isSuccess, isFault);
    fetchAslDeviceDetails(dispatcher);
}

async function updateAslMonitoringSchedule(dispatcher, request) {
    // Update asset details
    const startTime = Date.now();
    const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
    const updateAssetInPlaceResponse = await updateAssetInPlace(request, chainWalk(() => getAssetResult.data.asset.assetDetails.lastUpdateTime, null));
    const isSuccess = updateAssetInPlaceResponse.status === 200;
    const isFault = isResponseCode5xx(updateAssetInPlaceResponse.status)
    logOperationalMetric(startTime, metricProcessName, "updateAslDeviceDetails", isSuccess, isFault);
    fetchAslDeviceDetails(dispatcher);
}

function mergeStatusToModel(response, model) {
    if ("data" in response && "aslStatusList" in response.data) {
        response.data.aslStatusList.forEach((singleAslDeviceStatusDetail) => {
            model.aslDeviceInformation[singleAslDeviceStatusDetail.mac].assetStatus = singleAslDeviceStatusDetail.status
        })
    }
}

const updateExistingAssetAttributes = (asset, stateValues) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.assetAttributes.monitoring =
        chainWalk(() => JSON.stringify(stateValues), asset.assetDetails.assetAttributes.monitoring)
    return updatedAsset;
}

export async function updateAslMonitoringDetails(dispatcher, stateValues, mac){
    // Get existing details
    const getAssetResult = await getAssetByAssetLabel(getAssetLabelFromMac(mac));

    const updatedAsset = updateExistingAssetAttributes(getAssetResult.data.asset, stateValues);
    updateAslMonitoringSchedule(dispatcher, updatedAsset)
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/asldevice/network/AslDeviceOverviewNetworkAPI.js